<template>
  <div class="newdirect-wrap">
    <ul class="modal-form">
      <el-form :model="formData" :rules="rules" ref="directFormRef">
        <li class="form-item" v-show="!isUnit">
          <span class="form-label">定向方式：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.auto_target">
              <el-radio :label="0">自定义定向</el-radio>
              <el-radio :label="1">智能定向</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">自定义人群：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.audience_type">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定人群</el-radio>
            </el-radio-group>
            <div class="sub-wrap" v-if="formData.audience_type === 1">
              <list-check
                ref="customRqRef"
                :dataList="audienceList"
                :isAutoTarge="
                  formData.auto_target === 1 && formData.audience_type === 1
                "
              ></list-check>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">地域：</span>
          <div class="form-value">
            <el-radio-group
              v-model="formData.district"
              @change="changeBreakList('district')"
            >
              <el-radio label="">不限</el-radio>
              <el-radio label="CITY">按省市</el-radio>
            </el-radio-group>
            <div
              class="region-select-wrap"
              v-show="formData.district === 'CITY'"
            >
              <div class="region-content">
                <el-cascader
                  class="cascader-wrap"
                  v-model="formData.region"
                  :options="regionOptions"
                  collapse-tags
                  :props="{
                    multiple: true,
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                  }"
                  clearable
                ></el-cascader>
                <el-button
                  class="select-all-btn"
                  type="text"
                  @click="selectAllRegion"
                  >全选</el-button
                >
              </div>
            </div>
          </div>
        </li>
        <li class="form-item" v-if="formData.district === 'CITY' && !isUnit">
          <span class="form-label">用户类型：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.user_type">
              <el-radio :label="2">不限</el-radio>
              <el-radio :label="0">实时</el-radio>
              <el-radio :label="1">常驻</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">年龄：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('ages_range')">
              <el-checkbox v-model="unage">不限</el-checkbox>
            </div>
            <el-checkbox-group v-model="formData.ages_range">
              <el-checkbox :label="18">18-23</el-checkbox>
              <el-checkbox :label="24">24-30</el-checkbox>
              <el-checkbox :label="31">31-40</el-checkbox>
              <el-checkbox :label="41">41-49</el-checkbox>
              <el-checkbox :label="50">50+</el-checkbox>
            </el-checkbox-group>
          </div>
        </li>

        <li class="form-item">
          <span class="form-label">性别：</span>
          <div class="form-value">
            <el-radio-group
              v-model="formData.gender"
              @change="changeBreakList('gender')"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="2">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item" v-show="formData.auto_target === 0">
          <span class="form-label">行为意向：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.interest_action_mode">
              <el-radio label="UNLIMITED">不限</el-radio>
              <el-radio label="RECOMMEND" v-show="!isUnit">系统推荐</el-radio>
              <el-radio label="CUSTOM">自定义</el-radio>
            </el-radio-group>
            <div
              class="interest-wrap"
              v-show="formData.interest_action_mode === 'CUSTOM'"
            >
              <div class="transfer-wrap">
                <span class="transfer-title">行为：</span>
                <el-form-item prop="behavior_interest">
                  <div class="wrap-header">
                    <span class="header-text">行为在</span>
                    <el-select
                      v-model="formData.behavior_interest.behavior.scene_type"
                      style="width: 160px"
                      multiple
                      collapse-tags
                    >
                      <el-option label="社区" :value="1"></el-option>
                      <el-option label="APP" :value="2"></el-option>
                      <el-option label="电商" :value="3"></el-option>
                      <el-option label="推广" :value="4"></el-option>
                    </el-select>
                    <span class="header-text">中，选择用户</span>
                    <el-select
                      v-model="formData.behavior_interest.behavior.time_type"
                      style="width: 90px"
                    >
                      <el-option label="7天" :value="0"> </el-option>
                      <el-option label="15天" :value="1"> </el-option>
                      <el-option label="30天" :value="2"> </el-option>
                      <el-option label="90天" :value="3"> </el-option>
                      <el-option label="180天" :value="4"> </el-option>
                    </el-select>
                    <span class="header-text">内发生行为：</span>
                  </div>
                </el-form-item>
                <div
                  class="wrap-header"
                  style="
                    margin: 12px 0 4px 0;
                    display: flex;
                    align-item: center;
                  "
                >
                  <span class="header-text">行为强度</span>
                  <el-radio-group
                    v-model="formData.behavior_interest.behavior.strength_type"
                  >
                    <el-radio :label="0">不限</el-radio>
                    <el-radio :label="1">高强度</el-radio>
                  </el-radio-group>
                </div>
                <interest-transfer
                  :options="transferList.behaviorList"
                  ref="actionRef"
                ></interest-transfer>
                <span class="transfer-title" v-show="!isUnit">兴趣：</span>
                <div
                  class="wrap-header"
                  style="margin: 4px 0; display: flex; align-item: center"
                  v-show="!isUnit"
                >
                  <span class="header-text">行为强度</span>
                  <el-radio-group
                    v-model="formData.behavior_interest.interest.strength_type"
                  >
                    <el-radio :label="0">不限</el-radio>
                    <el-radio :label="1">高强度</el-radio>
                  </el-radio-group>
                </div>
                <interest-transfer
                  v-show="!isUnit"
                  :options="transferList.interestList"
                  ref="interestRef"
                ></interest-transfer>
              </div>
            </div>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">过滤已转化用户：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.filter_converted_level">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">广告组</el-radio>
              <el-radio :label="2">广告计划</el-radio>
              <el-radio :label="3">本账户</el-radio>
              <el-radio :label="4">公司主体</el-radio>
              <el-radio :label="5">APP</el-radio>
              <el-radio :label="6">运营自定义产品名</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item">
          <span class="form-label">操作系统：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.platform_os" disabled>
              <el-radio :label="2">iOS</el-radio>
              <el-radio :label="1">Android</el-radio>
            </el-radio-group>
          </div>
        </li>
        <li class="form-item" v-show="formData.platform_os === 1">
          <span class="form-label" style="padding-top: 6px">安卓版本：</span>
          <div class="form-value">
            <el-select v-model="formData.android_osv">
              <el-option
                v-for="item of android_osv_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="form-item" v-show="formData.platform_os === 2">
          <span class="form-label" style="padding-top: 6px">IOS版本：</span>
          <div class="form-value">
            <el-select v-model="formData.ios_osv">
              <el-option
                v-for="item of ios_osv_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </li>
        <li
          class="form-item"
          v-if="formData.auto_target === 0 && formData.platform_os === 1"
        >
          <span class="form-label">设备品牌：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.device_brand_type">
              <el-radio label="">不限</el-radio>
              <el-radio label="1">按品牌</el-radio>
            </el-radio-group>
            <el-transfer
              v-show="formData.device_brand_type === '1'"
              class="brand-transfer"
              filterable
              filter-placeholder="请输入品牌查询"
              v-model="formData.device_brand"
              :data="brandList"
            ></el-transfer>
          </div>
        </li>
        <li class="form-item" v-if="formData.auto_target === 0">
          <span class="form-label">设备价格：</span>
          <div class="form-value" style="display: flex">
            <div style="margin-right: 20px" @click="noSelect('device_price')">
              <el-checkbox v-model="undevice_price">不限</el-checkbox>
            </div>
            <div class="price-group">
              <el-checkbox-group v-model="formData.device_price">
                <el-checkbox :label="11">1000元以下</el-checkbox>
                <el-checkbox :label="12">1001~1500</el-checkbox>
                <el-checkbox :label="2">1501~2000</el-checkbox>
                <el-checkbox :label="3">2001~2500</el-checkbox>
                <el-checkbox :label="4">2501~3000</el-checkbox>
                <el-checkbox :label="5">3001~3500</el-checkbox>
                <el-checkbox :label="6">3501~4000</el-checkbox>
                <el-checkbox :label="7">4001~4500</el-checkbox>
                <el-checkbox :label="8">4501~5000</el-checkbox>
                <el-checkbox :label="9">5001~5500</el-checkbox>
                <el-checkbox :label="10">5500元以上</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </li>

        <!-- 安卓时显示app行为 -->
        <li
          class="form-item"
          v-if="formData.platform_os === 1 && formData.auto_target === 0"
        >
          <span class="form-label">APP行为：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.app_xwtype">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1" v-show="!isUnit">按分类</el-radio>
              <el-radio :label="2">按APP名称</el-radio>
            </el-radio-group>
            <div class="sub-wrap" v-if="formData.app_xwtype === 1">
              <el-cascader
                size="small"
                v-model="formData.app_interest_ids"
                :options="appIntestList"
                :props="{
                  multiple: true,
                  value: 'id',
                  label: 'name',
                  emitPath: false,
                }"
                clearable
                collapse-tags
                placeholder="选择app分类"
              ></el-cascader>
            </div>
            <div class="sub-wrap" v-if="formData.app_xwtype === 2">
              <el-select
                multiple
                collapse-tags
                v-model="formData.app_ids"
                filterable
                placeholder="搜索app名称"
                remote
                reserve-keyword
                :remote-method="remoteAppList"
                :loading="loadingSearch"
              >
                <el-option
                  v-for="item in appNameList"
                  :key="item.app_id"
                  :label="item.app_name"
                  :value="item.app_id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </li>

        <li class="form-item" v-if="formData.auto_target === 0">
          <span class="form-label">网络：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.network">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">Wi-Fi</el-radio>
              <el-radio :label="2">移动网络</el-radio>
            </el-radio-group>
          </div>
        </li>

        <li class="form-item" v-if="formData.auto_target === 0 && !isUnit">
          <span class="form-label">智能扩量：</span>
          <div class="form-value" style="display: flex; align-item: center">
            <el-switch
              v-model="formData.is_open"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
            <span
              style="font-size: 14px; color: #606266; margin: 0 5px"
              v-show="formData.is_open === 1"
              >不可突破</span
            >
            <el-checkbox-group
              v-model="formData.breakList"
              v-show="formData.is_open === 1"
            >
              <el-checkbox label="no_age_break" :disabled="unage"
                >年龄</el-checkbox
              >
              <el-checkbox
                label="no_gender_break"
                :disabled="formData.gender === 0"
                >性别</el-checkbox
              >
              <el-checkbox
                label="no_area_break"
                :disabled="formData.district === ''"
                >地域</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </li>

        <li class="form-item" v-if="isUnit">
          <span class="form-label">媒体定向：</span>
          <div class="form-value">
            <el-radio-group v-model="formData.mtdx">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">行业优质媒体</el-radio>
            </el-radio-group>
            <div class="mtdx-wrap" v-if="formData.mtdx === 1">
              <el-radio-group v-model="formData.mtdxData">
                <el-radio :label="1">超休闲游戏</el-radio>
                <el-radio :label="2">重度游戏</el-radio>
                <el-radio :label="3">特型广告</el-radio>
                <el-radio :label="4">直营电商</el-radio>
                <el-radio :label="5">平台电商</el-radio>
                <el-radio :label="6">教育行业</el-radio>
              </el-radio-group>
            </div>
          </div>
        </li>

        <li class="form-item">
          <span class="form-label" style="padding-top: 6px">定向包名称：</span>
          <div class="form-value">
            <el-input
              type="text"
              placeholder="请填写"
              maxlength="10"
              show-word-limit
              style="width: 280px"
              v-model="formData.targeting_name"
            ></el-input>
          </div>
        </li>
      </el-form>
    </ul>
    <div class="button-wrap" style="text-align: right">
      <el-button
        type="primary"
        :disabled="!(adCount && checkedApp.os_type)"
        @click="saveDirectPkg"
        :loading="saveLoading"
        >保存到定向包</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  audience,
  getPackParams,
  behavioAndInterest,
  targetTag,
  appSearch,
  newPack,
} from "@/api/promotion-kuaishou.js";
import InterestTransfer from "./interestTransfer.vue";
import optionList from "./optionData.js";
import { mapState } from "vuex";
import ListCheck from "../common/listCheck.vue";
export default {
  components: {
    InterestTransfer,
    ListCheck,
  },
  data() {
    return {
      formData: {
        auto_target: 0,
        district: "",
        region: [],
        user_type: 2,
        ages_range: [],
        gender: 0,
        platform_os: 2,
        android_osv: "3",
        ios_osv: "6",
        network: 0,
        device_brand_type: "",
        device_brand: [],
        device_price: [],
        app_xwtype: 0,
        app_interest_ids: [], //app行为，按分类
        app_ids: [], //app行为, 按app名称
        filter_converted_level: 0,
        targeting_name: "",
        //自定义人群相关
        audience_type: 0,
        //只能扩量相关
        is_open: 0,
        breakList: [],
        //行为意向相关
        interest_action_mode: "UNLIMITED",
        behavior_interest: {
          behavior: {
            time_type: 4,
            strength_type: 0,
            scene_type: [],
          },
          interest: {
            strength_type: 0,
          },
        },
        mtdx: 0,
        mtdxData: 1,
      },
      audienceList: [], //人群包数据
      regionOptions: [],
      brandList: [
        { label: "OPPO", key: "1" },
        { label: "VIVO", key: "2" },
        { label: "华为", key: "3" },
        { label: "小米", key: "4" },
        { label: "荣耀", key: "5" },
        { label: "三星", key: "6" },
        { label: "金立", key: "7" },
        { label: "魅族", key: "8" },
        { label: "乐视", key: "9" },
        { label: "其他", key: "10" },
        { label: "苹果", key: "11" },
      ],
      transferList: {
        behaviorList: [],
        interestList: [],
      },
      saveLoading: false,
      android_osv_list: optionList.android_osv_list,
      ios_osv_list: optionList.ios_osv_list,
      appIntestList: [], //app行为
      appNameList: [], //app行为名称搜索
      loadingSearch: false,
      isUnit: false, //是否快手联盟
      rules: {
        behavior_interest: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (
                this.formData.interest_action_mode === "CUSTOM" &&
                value.behavior.scene_type.length === 0
              ) {
                callback(new Error("部分数据填写不完整"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getOptionList();
  },
  methods: {
    formatData() {
      let res = JSON.parse(JSON.stringify(this.formData));
      //自定义人群
      if (res.audience_type === 1) {
        let exData = this.$refs.customRqRef.selectItem;
        res.audience = {};
        let include = exData.includeList.map((item) => item.id);
        let exclude = exData.excludeList.map((item) => item.id);
        if (include.length > 0) {
          res.audience.include = include;
        }
        if (exclude.length > 0) {
          res.audience.exclude = exclude;
        }
      }
      //地区,用户类型
      if (res.district === "") {
        res.region = [];
        delete res.user_type;
      } else if (this.isUnit) {
        delete res.user_type;
      }
      delete res.district;

      //年龄
      if (res.ages_range.length === 0) {
        delete res.ages_range;
      }
      //行为兴趣（智能定向不展示）
      if (res.auto_target === 1) {
        //智能定向
        delete res.behavior_interest;
        res.interest_action_mode = "UNLIMITED"; //还原类型设置
      } else {
        if (res.interest_action_mode === "CUSTOM") {
          res.behavior_interest.behavior.label =
            this.$refs.actionRef.getSelectList();
          res.behavior_interest.interest.label =
            this.$refs.interestRef.getSelectList();
        } else {
          delete res.behavior_interest;
        }
      }
      //平台类型
      if (res.platform_os === 2) {
        delete res.android_osv;
      } else {
        delete res.ios_osv;
      }
      //设备品牌
      if (res.device_brand_type === "") {
        res.device_brand = [];
      }
      delete res.device_brand_type;

      //app行为
      if (res.app_xwtype === 0) {
        delete res.app_interest_ids;
        delete res.app_ids;
      } else if (res.app_xwtype === 1) {
        delete res.app_ids;
      } else if (res.app_xwtype === 3) {
        delete res.app_interest_ids;
      }
      //智能扩量
      if (res.is_open === 1) {
        let intelli_extend = {
          is_open: res.is_open,
        };
        this.formData.breakList.forEach((item) => {
          intelli_extend[item] = 1;
        });
        res.intelli_extend = intelli_extend;
      }
      delete res.is_open;
      delete res.breakList;
      return res;
    },
    saveDirectPkg() {
      if (this.formData.targeting_name === "") {
        this.$alert("定向包名称必填", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let parmas = this.formatData();
      this.saveLoading = true;
      newPack({
        platType: 3,
        advertiserId: this.adCount.advertiserId,
        platform_os: this.checkedApp.os_type || null,
        data: JSON.stringify(parmas),
      }).then((res) => {
        this.saveLoading = false;
        if (res.code === "0000") {
          this.$message({
            message: "定向包新建成功",
            type: "success",
          });
        }
      });
    },
    checkData() {
      this.$refs.directFormRef.validate(() => {});
    },
    fillData(dataItem) {
      this.formData.auto_target = dataItem.auto_target;

      this.formData.audience_type = dataItem.audience_type;
      if (dataItem.audience_type === 1) {
        this.$nextTick(() => {
          if (this.audienceList.length > 0) {
            this.$refs.customRqRef.selectItem.includeList = dataItem.audience
              .include
              ? dataItem.audience.include.map((id) => {
                  return this.audienceList.find((item) => item.id === id);
                })
              : [];
            this.$refs.customRqRef.selectItem.excludeList = dataItem.audience
              .exclude
              ? dataItem.audience.exclude.map((id) => {
                  return this.audienceList.find((item) => item.id === id);
                })
              : [];
          } else {
            if (!this.adCount.advertiserId) {
              console.log("没有advertiseid");
            } else {
              this.searchAudienceList(this.adCount.advertiserId, () => {
                this.$refs.customRqRef.selectItem.includeList = dataItem
                  .audience.include
                  ? dataItem.audience.include.map((id) => {
                      return this.audienceList.find((item) => item.id === id);
                    })
                  : [];
                this.$refs.customRqRef.selectItem.excludeList = dataItem
                  .audience.exclude
                  ? dataItem.audience.exclude.map((id) => {
                      return this.audienceList.find((item) => item.id === id);
                    })
                  : [];
              });
            }
          }
        });
      }

      this.formData.region = dataItem.region;
      this.formData.district = dataItem.region.length > 0 ? "CITY" : "";
      this.formData.user_type =
        dataItem.user_type === undefined ? 2 : dataItem.user_type;
      this.formData.ages_range = dataItem.ages_range || [];
      this.formData.gender = dataItem.gender;

      this.formData.interest_action_mode = dataItem.interest_action_mode;
      if (dataItem.auto_target === 0) {
        //自定义定向才显示行为兴趣
        if (dataItem.interest_action_mode === "CUSTOM") {
          this.formData.behavior_interest = dataItem.behavior_interest;
          this.searchInterest(this.adCount.advertiserId, () => {
            this.$refs.actionRef.setSelectList(
              dataItem.behavior_interest.behavior.label
            );
            this.$refs.interestRef.setSelectList(
              dataItem.behavior_interest.interest.label
            );
          });
        } else {
          (this.formData.behavior_interest = {
            behavior: {
              time_type: 4,
              strength_type: 0,
              scene_type: [],
            },
            interest: {
              strength_type: 0,
            },
          }),
            this.$refs.actionRef.setSelectList([]);
          this.$refs.interestRef.setSelectList([]);
        }
      }

      this.formData.filter_converted_level = dataItem.filter_converted_level;
      this.formData.platform_os = dataItem.platform_os;
      if (dataItem.platform_os === 2) {
        this.formData.ios_osv = dataItem.ios_osv || "6";
      } else {
        this.formData.android_osv = dataItem.android_osv || "3";
      }

      this.formData.device_brand = dataItem.device_brand;
      this.formData.device_brand_type =
        dataItem.device_brand.length > 0 ? "1" : "";

      this.formData.device_price = dataItem.device_price;

      this.formData.app_xwtype = dataItem.app_xwtype;
      if (dataItem.app_xwtype === 1) {
        this.formData.app_interest_ids = dataItem.app_interest_ids;
      } else if (dataItem.app_xwtype === 2) {
        this.formData.app_ids = dataItem.app_ids;
      } else {
        this.formData.app_interest_ids = [];
        this.formData.app_ids = [];
      }

      this.formData.network = dataItem.network;

      if (dataItem.intelli_extend) {
        this.formData.is_open = 1;
        this.formData.breakList = Object.keys(dataItem.intelli_extend).filter(
          (item) => item !== "is_open"
        );
      } else {
        this.formData.is_open = 0;
        this.formData.breakList = [];
      }

      this.formData.mtdx = dataItem.mtdx;
      this.formData.mtdxData = dataItem.mtdxData;

      this.formData.targeting_name = dataItem.targeting_name;
    },
    noSelect(field) {
      if (field === "ages_range") {
        let delIndex = this.formData.breakList.findIndex(
          (item) => item === "no_age_break"
        );
        if (delIndex !== -1) {
          this.formData.breakList.splice(delIndex, 1);
        }
      }
      this.formData[field] = [];
    },
    changeBreakList(field) {
      let val = this.formData[field];
      if (field === "district" && val === "") {
        let delIndex = this.formData.breakList.findIndex(
          (item) => item === "no_area_break"
        );
        if (delIndex !== -1) {
          this.formData.breakList.splice(delIndex, 1);
        }
      } else if (field === "gender" && val === 0) {
        let delIndex = this.formData.breakList.findIndex(
          (item) => item === "no_gender_break"
        );
        if (delIndex !== -1) {
          this.formData.breakList.splice(delIndex, 1);
        }
      }
    },
    //地区数据
    getOptionList() {
      getPackParams({
        platType: 3,
      }).then((res) => {
        this.regionOptions = res.region;
      });
    },
    selectAllRegion() {
      setTimeout(() => {
        let allData = [];
        const getId = (item) => {
          if (item.children) {
            item.children.forEach(getId);
          } else {
            allData.push(item.id);
          }
        };
        this.regionOptions.forEach(getId);
        this.formData.region = allData;
      });
    },
    //查询人群包
    searchAudienceList(advertiserId, cb) {
      audience({
        advertiserId: advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.audienceList = res.audiencePacks.map((item) => {
            item.id = item.orientation_id;
            item.name = item.orientation_name;
            return item;
          });
          if (cb) {
            cb.call(this);
          }
        }
      });
    },
    //查询行为类目词
    searchInterest(advertiserId, cb) {
      behavioAndInterest({
        advertiserId: advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.transferList.behaviorList = res.behaviorAndInterst.behavior;
          this.transferList.interestList = res.behaviorAndInterst.interest;
          if (cb) {
            cb.call(this);
          }
        }
      });
    },
    //查询app行为
    searchAppTag(advertiserId) {
      targetTag({
        advertiserId: advertiserId,
        type: "APP_INTEREST_ID",
      }).then((res) => {
        if (res.code === "0000") {
          let treeData = [];
          for (let [name, item] of Object.entries(res.map)) {
            treeData.push({
              name: name,
              id: Math.random(),
              children: item,
            });
          }
          this.appIntestList = treeData;
        }
      });
    },
    //根据名称输入查询
    remoteAppList(value) {
      if (this.adCount) {
        this.loadingSearch = true;
        appSearch({
          advertiserId: this.adCount.advertiserId,
          appName: value,
        }).then((res) => {
          this.loadingSearch = false;
          if (res.code === "0000") {
            this.appNameList = res.converts;
          }
        });
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionKuaishou.adCount,
      checkedApp: (state) => state.PromotionKuaishou.checkedApp,
      delivery_range: (state) =>
        state.PromotionKuaishou.draft_adset.delivery_placement.delivery_range,
    }),
    unage: {
      get() {
        return this.formData.ages_range.length === 0 ? true : false;
      },
      set() {},
    },
    undevice_price: {
      get() {
        return this.formData.device_price.length === 0 ? true : false;
      },
      set() {},
    },
  },
  watch: {
    adCount(value) {
      if (value && value.advertiserId) {
        this.searchAudienceList(value.advertiserId);
        this.searchInterest(value.advertiserId);
        this.searchAppTag(value.advertiserId);
      }
    },
    checkedApp(value) {
      if (value && value.os_type) {
        this.formData.platform_os = value.os_type === "IOS" ? 2 : 1;
      }
    },
    //投放范围联动广告位置
    delivery_range(value) {
      if (value === "default") {
        if (this.formData.interest_action_mode === "RECOMMEND") {
          this.formData.interest_action_mode = "UNLIMITED";
        }
        this.isUnit = false;
      } else if (value === "unit") {
        this.formData.auto_target = 0; //自定义定向
        this.isUnit = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.newdirect-wrap {
  box-sizing: border-box;
  padding-top: 10px;
  .modal-form {
    margin: 0px;
    padding: 0px;
    list-style: none;
    .form-item {
      display: flex;
      margin-bottom: 20px;
      .form-label {
        flex-shrink: 0;
        display: inline-block;
        width: 114px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        // padding-top: 6px;
      }
      .form-value {
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(0, 0, 0, 0.65);
        }
        .brand-transfer {
          margin-top: 10px;
          /deep/ .el-transfer-panel {
            width: 180px;
            height: 300px;
          }
        }
        .region-select-wrap {
          padding-top: 10px;
          .region-content {
            margin-top: 10px;
            display: flex;
            align-items: center;
            .cascader-wrap {
              width: 100%;
            }
            .select-all-btn {
              margin-left: 10px;
            }
          }
        }
        .interest-wrap {
          margin-top: 10px;
          .wrap-header {
            display: flex;
            align-items: center;
            .header-text {
              margin: 0 5px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
            }
          }
          .transfer-wrap {
            .transfer-title {
              display: block;
              padding: 10px 6px 6px 0;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
        .custom-wrap {
          margin-top: 10px;
        }
        .sub-wrap {
          margin-top: 12px;
        }
        .price-group {
          /deep/.el-checkbox {
            margin-bottom: 10px;
          }
        }
        .mtdx-wrap {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>